module.exports = __webpack_public_path__ + "media/images/dog_placeholder-fa213229.png";